<template>
    <CommonItem
        :title="textField"
        :desc="deptNames"
        :img-url="complete(`user/photo.htm?uid=${idField}`)"
        :show-checkbox="showCheckbox"
    />
</template>

<script>
import CommonItem from "@/components/OrgSelector/CommonItem"
import {complete} from "@/utils/url";
export default {
    name: 'UserItem',
    components: {
        CommonItem,
    },
    props: ['textField', 'type', 'idField', 'deptNames', 'showCheckbox'],
    data() {
        return {
        }
    },
    computed: {},
    methods: {
      complete
    },
    created() {
    }
}
</script>